<template>
  <div class="w-full rounded px-2 pt-2 pb-8 mb-6">
    <el-row :gutter="20">
      <el-col :span="24" class="mb-6">
        <el-button icon="el-icon-back" size="small"
                   @click="$router.push('/ecommerce/supply/suppliers')">Back to list</el-button>
        <el-button type="danger" icon="el-icon-delete" size="small" class="float-right"
                   @click="onDeleteSupplier(updateForm.id)">Delete</el-button>
        <el-button class="float-right" type="primary" icon="el-icon-plus" size="small"
                   @click="$router.push('/ecommerce/supply/suppliers/new')">New</el-button>
      </el-col>
    </el-row>
    <el-form :model="updateForm" :label-position="labelPosition" :rules="rules" ref="updateForm" v-loading="loading">
      <SuppliersForm :form="updateForm" />
      <el-form-item :gutter="20" class="px-5">
        <el-button type="primary" @click="update('updateForm')" :loading="updating">Update</el-button>
        <el-button @click="cancelUpdate" type="info">Close</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import SuppliersForm from './_includes/SuppliersForm.vue';

export default {
  name: 'UpdateSuppliers',
  components: {
    SuppliersForm,
  },
  data() {
    return {
      loading: false,
      updating: false,
      labelPosition: 'top',
      rules: this.$store.state.InventoryModule.Suppliers.validate_form,
    };
  },
  computed: {
    countries() {
      return this.$store.state.SettingsModule.Location.countries.data;
    },
    states() {
      return this.$store.state.SettingsModule.Location.states;
    },
    cities() {
      return this.$store.state.SettingsModule.Location.cities;
    },
    groups() {
      return this.$store.state.InventoryModule.SuppliersGroup.suppliers_groups;
    },
    updateForm() {
      return this.$store.state.InventoryModule.Suppliers.supplier;
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    const page = 1; const limit = 1000;
    try {
      this.loading = true;
      await this.$store.dispatch('InventoryModule/Suppliers/getSupplier', this.$route.params.id);
      await this.$store.dispatch('SettingsModule/Location/fetchMerchantCountries', { page, limit });
      await this.$store.dispatch('InventoryModule/SuppliersGroup/fetchAllSuppliersGroups');
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
    this.loading = false;
  },
  methods: {
    async cancelUpdate() {
      this.$router.back();
    },
    update(updateForm) {
      const formData = {
        name: this.updateForm.name,
        supplier_group_id: this.updateForm.supplier_group_id,
        email: this.updateForm.email,
        phone: this.updateForm.phone,
        country_id: this.updateForm.country_id,
        state_id: this.updateForm.state_id,
        city: this.updateForm.city,
        address: this.updateForm.address,
        contact_person: this.updateForm.contact_person,
        status: this.updateForm.status,
      };
      this.$refs[updateForm].validate(async (valid) => {
        if (valid) {
          try {
            this.updating = true;
            await this.$store.dispatch('InventoryModule/Suppliers/updateSupplier', {
              supplierId: this.$route.params.id, supplier: formData,
            });
            this.$notify.success({
              title: 'Success',
              message: 'Supplier update was successful.',
            });
            this.$router.back();
          } catch (e) {
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong please try again.',
            });
          }
          this.updating = false;
        } else {
          return false;
        }
      });
    },
    async onDeleteSupplier(supplierId) {
      this.$confirm('Are you sure you want to delete this supplier?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('InventoryModule/Suppliers/deleteSupplier', { supplierId });
          this.$notify.success({
            title: 'Success',
            message: 'Supplier has been deleted.',
          });
          await this.$router.push('/ecommerce/supply/suppliers');
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
    async onGetStates(countryId) {
      await this.$store.dispatch('SettingsModule/Location/fetchMerchantStates', { countryId });
    },
    async onGetCities(stateId) {
      await this.$store.dispatch('SettingsModule/Location/fetchMerchantCities', { stateId });
    },
  },
};
</script>

<style scoped>

</style>
